import * as T3_Ajax from 'T3_AJAX';
import * as Loader from 'LOADER';

import * as Chart from './_chart';
import {json} from "../../../../../../../public/typo3/sysext/core/Resources/Public/JavaScript/Contrib/d3/d3";
import {addClass} from "uikit/src/js/util";

const SELECTOR__SURVEY_CONTAINER = '.vd-survey';
const SELECTOR__SURVEY_FORM = '.vd-form.vd-form--survey';
const SELECTOR__SURVEY_ANSWER = '.answer';
const SELECTOR__SURVEY_ANSWER_SELECTION = '.answer__selection';
const SELECTOR__SURVEY_ANSWERS_BLOCK = '.answers-block';

const ACTION__NEXT_ANSWER = 'next-answer';
const ACTION__PREV_ANSWER = 'prev-answer';

const actions = () => {
  $('.content').first().find('.actions .actions__left').first().hide(0);

  $(document).on('click', '[data-action]', function (e) {
    let _self = $(this);
    switch (_self.attr('data-action')) {
      case 'next-step':
        e.preventDefault();
        nextStep(_self);
        break;
      case 'skip-answer':
        e.preventDefault();
        skipAnswer(_self);
        break;
      case 'rate-answer':
        e.preventDefault();
        rateAnswer(_self);
        break;
      case 'prev-step':
        e.preventDefault();
        prevStep($(this));
        break;
      case 'previous-answer':
        e.preventDefault();
        previousAnswer(_self);
        break;
    }
  });
};

const fetchFormData = (_form) => {
  let values = {};

  _form.find('select').each(function () {
    values[$(this).attr('id')] = $(this).val();
  });

  let serialized = JSON.stringify(values);
  return serialized;
};

/**
 * private
 */
const getActualAnswer = (_caller) => {
  return _caller.parents(SELECTOR__SURVEY_ANSWER);
};

const getLastAnswerOfCategory = () => {
  const form = $(SELECTOR__SURVEY_FORM);
  console.log('---form (getLastAnswerOfCategory)---');
  console.log(form);

  const _blocks = form.find(SELECTOR__SURVEY_ANSWERS_BLOCK);
  console.log('---blocks---');
  console.log(_blocks);
  const _answers = _blocks.last().find(SELECTOR__SURVEY_ANSWER);
  console.log('---answers of last block---');
  console.log(_answers);
  return _answers.last();
};

/**
 * private
 */
const getForm = (_caller) => {
  return $(_caller).parents(SELECTOR__SURVEY_CONTAINER).find(SELECTOR__SURVEY_FORM);
};

const getItemData = (_caller) => {
  let select = _caller.parents('.answer').find('select');
  let data = {};
  data[select.attr('name')] = select.val();

  return JSON.stringify(data);
};

const isFirstAnswer = () => {
  const _form = $('.vd-form.vd-form--survey');

  if (_form.attr('data-step-actual') !== '1') {
    return false;
  }
  const firstBlock = _form.find('.answers-block').first();

  if (!firstBlock.hasClass('status--active')) {
    return false;
  }
  const firstAnswer = firstBlock.find('.answer').first();
  if (!firstAnswer.hasClass('status--active')) {
    return false;
  }
  return true;
};

const fadeOverlay = (operation) => {
  if (typeof operation === 'undefined') {
    operation = 'show';
  }

  const duration = 125;
  const main = $('.body__container > main');
  const overlay = '<div class="main__overlay"></div>';

  if (operation === 'show') {
    if (main.find('.main__overlay').length < 1) {
      main.append(overlay);
    }
    main.find('.main__overlay').fadeIn(duration);
  }
  if (operation === 'hide') {
    if (main.find('.main__overlay').length > 0) {
      main.find('.main__overlay').fadeOut(duration);
    }
  }
};

const rateAnswer = (_caller) => {
  const duration = 100;

  const form = getForm(_caller);

  let actual = _caller.parents('.answer');
  let next = actual.next('.answer');
  const actualBlock = _caller.parents('.answers-block');
  const nextBlock = _caller.parents('.answers-block').next('.answers-block');

  let switchToNextBlock = false;
  var switchToSuccessMessage = false;

  /**
   * set value @select
   */
  const value = parseInt(_caller.find('span').text());
  _caller.parents('.rating').find('.rating__item').removeClass('status').removeClass('status--selected');
  _caller.addClass('status status--selected');

  actual.find('select').val(value).change();

  if (next.length < 1) {
    next = _caller.parents('.answers-block').next('.answers-block').find('.answer').first();
    if (next.length > 0) {
      switchToNextBlock = true;
    } else {
      switchToSuccessMessage = true;
    }
  }

  if (!switchToNextBlock && !switchToSuccessMessage) {
    actual.velocity('fadeOut', {
      display: 'none',
      duration: duration,
      begin: function () {
        toggleProcessingStatus('start');
        fadeOverlay('show');
      },
      complete: function () {
        next.velocity('fadeIn', {
          duration: duration,
          complete: function () {
            toggleAnswerStatus(actual, next);
            setProgress(_caller, 'next');
            saveData(_caller, next);
          },
        });
      },
    });
  }

  if (switchToNextBlock) {
    actualBlock.velocity('fadeOut', {
      duration: duration,
      begin: function () {
        toggleProcessingStatus('start');
        fadeOverlay('show');
        actual.velocity('fadeOut', {
          duration: duration,
        });
      },
      complete: function () {
        nextBlock.velocity('fadeIn', {
          duration: duration,
          begin: function () {
            next.velocity('fadeIn', {
              duration: duration,
            });
          },
          complete: function () {
            toggleAnswerStatus(actual, next);
            toggleAnswerStatus(actualBlock, nextBlock);
            saveData(_caller, next);
            setProgress(_caller, 'next');
            toggleProcessingStatus('stop');
            fadeOverlay('hide');
          },
        });
      },
    });
  }

  if (switchToSuccessMessage) {
    form.velocity('fadeOut', {
      duration: duration,
      begin: function () {
        toggleProcessingStatus('start');
        fadeOverlay('show');
        actualBlock.velocity('fadeOut', {
          duration: 100,
          begin: function () {
            actual.velocity('fadeOut', {
              duration: duration,
            });
          },
        });
      },
      complete: function () {
        toggleAnswerStatus(actual, null);
        toggleAnswerStatus(actualBlock, null);
        setProgress(_caller, 'next');
        saveData(_caller, null, switchToSuccessMessage);
      },
    });
  }
};

const nextStep = (_caller) => {
  const form = _caller.parents('form');
  const stepActual = form.attr('data-actual-step');
  const stepsOverall = form.attr('data-steps-overall');
  const token = form.attr('data-token');

  let params = {
    action: 'nextStep',
    controller: 'Ajax',
    extension: 'tx_vdsurveys',
    typeNum: 787839,
    step: form.attr('data-step-actual'),
    stepId: form.attr('data-step-id'),
    formData: fetchFormData(form),
  };

  T3_Ajax.call(
    params,
    _caller,
    function () {},
    function () {
      onSuccess__nextStep(_caller);
    }
  );
};

const onSuccess__nextStep = (_caller) => {
  let target = _caller.attr('data-target');
  if (typeof target === 'undefined') {
    target = _caller.parents('.vd-survey').find('.vd-form').attr('data-step-next-target');
  }
  window.location.href = target;
};

const prevStep = (_caller) => {
  let target = _caller.attr('data-target');
  if (typeof target === 'undefined') {
    target = _caller.parents('.vd-survey').find('.vd-form').attr('data-step-prev-target');
  }
  window.location.href = target;
};

const setGradientOffset = (progressGraphic, value) => {
  const gradient_id = '#def_gradient_active-1';
  progressGraphic.find(gradient_id + ' stop#actualPercentage').attr('offset', value);
  progressGraphic.find(gradient_id + ' stop#actualFade').attr('offset', value + 0.025);
};

const setProgress = (_caller, direction) => {
  if (typeof direction === 'undefined') {
    direction = 'next';
  }

  let progressElement = _caller
    .parents('.vd-survey')
    .find(
      '.vd-survey__navigation .vd-survey__navigation__category.status.status--active .progress'
    );

  let overall = $('.answer').length;
  let actual = 0;

  $('.answer').each(function () {
    if ($(this).hasClass('status--active')) {
      return false;
    }
    actual++;
  });

  let progress = (actual * 100) / overall;

  progressElement.velocity(
    {
      width: progress + '%',
      backgroundColor: progressElement
        .parents('.vd-survey__navigation')
        .attr('data-progress-color'),
    },
    {
      duration: 150,
    }
  );

  setProgressGraphic(_caller, actual, overall);
};

const setProgressGraphic = (_caller, actual, overall) => {
  let numberOfProcessPolygons = 2;

  /**
   * progress graphic
   */

  let progressGraphic = _caller
    .parents('.vd-survey')
    .find('.success-status.success-status--tiny svg');

  if ($('main .vd-survey .success-status.success-status--tiny').attr('data-noc') === '3') {
    numberOfProcessPolygons = 3;
  }

  const answersPerPolygon = overall / numberOfProcessPolygons;
  console.log('answers per polygon: ' + answersPerPolygon);

  const actualBlock = parseInt(
    _caller.parents('.vd-survey').find('.vd-form').attr('data-step-actual')
  );
  console.log('actualBlock: ' + actualBlock);

  let idCircleItem = 0;
  for (let i = 1; i <= numberOfProcessPolygons; i++) {
    if (actual <= i * answersPerPolygon) {
      idCircleItem = i;
      break;
    }
  }

  if (actualBlock > 1) {
    idCircleItem = idCircleItem + (actualBlock * numberOfProcessPolygons - numberOfProcessPolygons);
  }

  /* let idCircleItem =
    (parseInt(_caller.parents('.vd-survey').find('.vd-form').attr('data-step-actual')) - 1) *
    numberOfProcessPolygons;
  idCircleItem++; */

  console.log('actual: ' + actual);
  console.log('overall: ' + overall);

  console.log(
    'setProgressGraphic -> actual step: ' +
      parseInt(_caller.parents('.vd-survey').find('.vd-form').attr('data-step-actual'))
  );
  console.log('setProgressGraphic -> idCircleItem: ' + idCircleItem);

  /* if (actual > overall / numberOfProcessPolygons) {
    actual = actual - overall / numberOfProcessPolygons;
    idCircleItem++;
  } */

  //@TODO
  let percentage = 0;
  let themeColor = $('.body__container').hasClass('jrk') ? '#00a0aa':'#e60006';

  if (idCircleItem % numberOfProcessPolygons !== 1) {
    for (let i = idCircleItem - 1; i > 0; i--) {
      let itemId = i;
      progressGraphic
        .find('#circle_items__active polygon#circle_item_' + itemId)
        .attr('style', '')
        .addClass('status status--display')
        .css('fill', themeColor);
    }
  }
  var modulo = idCircleItem % numberOfProcessPolygons;
  console.log('modulo: ' + modulo);

  $('.debug').find('.actual').find('.value').text(actual);
  $('.debug').find('.overall').find('.value').text(overall);
  $('.debug').find('.modulo').find('.value').text(modulo);
  $('.debug').find('.idCircleItem').find('.value').text(idCircleItem);

  var test = overall - (actual / answersPerPolygon) * actualBlock;

  /**
   * percentage
   */
  let percentageDivider = modulo !== 0 ? modulo : numberOfProcessPolygons;
  $('.debug').find('.percentageDivider').find('.value').text(percentageDivider);
  if (idCircleItem > 1) {
    let subtrahent = Math.floor((idCircleItem - 1) * answersPerPolygon);
    let actPercentalCounter = actual - subtrahent;
  }

  //$('.debug').find('.test').text(actPercentalCounter);

  test =
    percentageDivider > 1
      ? actual - Math.floor(answersPerPolygon) / (percentageDivider - 1)
      : actual;
  $('.debug').find('.test').text(test);
  percentage = (test / answersPerPolygon) * 100;
  $('.debug').find('.percentage').find('.value').text(percentage);
  console.log(answersPerPolygon * actualBlock);
  console.log('percentage: ' + percentage);

  setGradientOffset(progressGraphic, percentage / 100);
  progressGraphic
    .find('#circle_items__active polygon#circle_item_' + idCircleItem)
    .attr('style', 'fill:url(#def_gradient_active-' + idCircleItem + ')');
};

const toggleAnswerStatus = (act, next) => {
  if (typeof act !== 'undefined' && act !== null) {
    act.removeClass('status--active').addClass('status status--hidden');
  }
  if (typeof next !== 'undefined' && next !== null) {
    next.removeClass('status--hidden').addClass('status status--active');
  }
};

const initProgressGraphic = () => {
  let numberOfProcessPolygons = 2;
  const selectorProgressGraphic = $('main .vd-survey .success-status.success-status--tiny svg');

  if ($('main .vd-survey .success-status.success-status--tiny').attr('data-noc') === '3') {
    numberOfProcessPolygons = 3;
  }
  console.log('number of polygons: ' + numberOfProcessPolygons);
  const progressGraphic = $(selectorProgressGraphic);

  if (progressGraphic.length === 0) {
    return false;
  }
  let themeColor = $('.body__container').hasClass('jrk') ? '#00a0aa':'#e60006';
  $(progressGraphic).find('#def_gradient_active-1').find('stop').attr('stop-color',themeColor);

  const actualStep = parseInt($('.vd-form.vd-form--survey').attr('data-step-actual'));
  const actualCircleItem = actualStep * numberOfProcessPolygons - (numberOfProcessPolygons - 1);

  console.log('actual circle item: ' + actualCircleItem);
  let i = 1;

  progressGraphic.find('#circle_items__active polygon').each(function () {
    if (i < actualCircleItem) {
      $(this).addClass('status status--display').css('fill', themeColor);
    }

    i++;
  });
};

const skipAnswer = (_caller) => {
  const form = getForm(_caller);
  let actAnswer = getActualAnswer(_caller);
  actAnswer.find(SELECTOR__SURVEY_ANSWER_SELECTION).val(0);

  rateAnswer(_caller);
};

const getNextAnswer = () => {
  const actAnswer = $('.answer.status.status--active');
  let nextAnswer = null;

  if (actAnswer.length === 0) {
    return null;
  }

  nextAnswer = actAnswer.next();
  if (nextAnswer.length > 0) {
    return nextAnswer;
  } else {
    let nextAnswersBlock = actAnswer.parents('.answers-block').next('.answers-block');
    if (nextAnswersBlock.length === 0) {
      return null;
    } else {
      nextAnswersBlock.find('.answer').first();
    }
  }
  return null;
};

const getPreviousAnswer = () => {
  const actAnswer = $('.answer.status.status--active');
  let prevAnswer = null;

  if (actAnswer.length === 0) {
    prevAnswer = $('.answer').last();
  } else {
    prevAnswer = actAnswer.prev();
    if (prevAnswer.length === 0) {
      prevAnswer = actAnswer.parents('.answers-block').prev().find('.answer').last();
    }
  }

  return prevAnswer;
};

const previousAnswer = (_caller) => {
  const duration = 100;
  const form = getForm(_caller);

  getPreviousAnswer();

  let actAnswer = null;
  let prevAnswer = null;

  let switchBlock = false;
  let switchFromSuccess = false;
  console.log(_caller.parents('.additionalContent'));
  if (
    _caller.parents('.additionalContent').find('[data-ctype="vd_survey_success_message"]').length >
    0
  ) {
    switchFromSuccess = true;
    switchBlock = true;
    prevAnswer = getLastAnswerOfCategory();
  } else {
    actAnswer = getActualAnswer(_caller);
    prevAnswer = actAnswer.prev();
    switchBlock = true;
  }
  let actual = prevAnswer.parents('.answer').first();

  if (prevAnswer.length < 1) {
    prevAnswer = actAnswer.parents('.answers-block').prev('.answers-block').find('.answer').last();
    switchBlock = true;
  }

  if (!switchBlock && !switchFromSuccess) {
    actAnswer.velocity('fadeOut', {
      duration: 100,
      begin: function () {
        toggleProcessingStatus('start');
      },
      complete: function () {
        prevAnswer.velocity('fadeIn', {
          duration: duration,
          complete: function () {
            toggleAnswerStatus(actAnswer, prevAnswer);
            toggleAnswerStatus(
              actAnswer.parents('.ansers-block'),
              prevAnswer.parents('.ansers-block')
            );
            setProgress(_caller);
            toggleProcessingStatus('stop');
          },
        });
      },
    });
  }

  if (switchFromSuccess) {
    $('.success-status.success-status--extended').velocity('fadeOut', {
      duration: duration,
      begin: function () {
        toggleProcessingStatus('start');
        _caller.parents('.additionalContent').velocity('fadeOut', {
          duration: duration,
        });
      },
      complete: function () {
        form.velocity('fadeIn', {
          duration: duration,
          begin: function () {
            prevAnswer.parents('.answers-block').velocity('fadeIn', {
              duration: duration,
              begin: function () {
                prevAnswer.velocity('fadeIn', {
                  duration: duration,
                  complete: function () {
                    toggleAnswerStatus(null, prevAnswer);
                    toggleAnswerStatus(null, prevAnswer.parents('.ansers-block'));
                    setProgress(_caller);
                    //$('footer').show(0);
                  },
                });
              },
            });
          },
        });

        toggleProcessingStatus('stop');
      },
    });
  }
  if (switchBlock) {
    actAnswer.parents('.answers-block').velocity('fadeOut', {
      duration: 100,
      begin: function () {
        actAnswer.velocity('fadeOut', {
          duration: 100,
        });
      },
      complete: function () {
        prevAnswer.parents('.answers-block').velocity('fadeIn', {
          duration: duration,
          begin: function () {
            prevAnswer.velocity('fadeIn', {
              duration: duration,
              complete: function () {
                toggleAnswerStatus(actAnswer, prevAnswer);
                toggleAnswerStatus(
                  actAnswer.parents('.ansers-block'),
                  prevAnswer.parents('.ansers-block')
                );
                setProgress(_caller);
                toggleProcessingStatus('stop');
              },
            });
          },
        });
      },
    });
  }
};

const toggleBlockSuccessMessage = (switchFromSuccess) => {
  if (switchFromSuccess) {
    $('.additionalContent, .additionalContent > *').velocity(
      {
        opacity: 0,
      },
      {
        duration: 0,
        display: 'none',
        begin: function () {
          $('.vd-form').velocity(
            {
              opacity: 1,
            },
            {
              duration: 50,
              display: 'block',
            }
          );
        },
      }
    );
  } else {
    $('vd-form').velocity(
      {
        opacity: 0,
      },
      {
        display: 'none',
        begin: function () {
          $('.additionalContent, .additionalContent > *').velocity(
            {
              opacity: 0,
            },
            {
              duration: 0,
              display: 'none',
              duration: 50,
            }
          );
        },
      }
    );
  }
};

const switchAnswer = (actual, next, switchBlock) => {
  if (switchBlock) {
    if (actual !== null) {
      next
        .parents(SELECTOR__SURVEY_FORM)
        .velocity({ opacity: 1 }, { duration: 0, display: 'block' });
      actual
        .parents('.answers-block')
        .removeClass('status--active')
        .addClass('status--hidden')
        .velocity(
          {
            opacity: 0,
          },
          {
            display: 'none',
            queque: false,
          }
        );
    } else {
    }
    console.log('---next.parents()');
    next.parents('.answers-block');
    next
      .parents('.answers-block')
      .removeClass('status--hidden')
      .addClass('status--active')
      .velocity(
        {
          opacity: 1,
        },
        {
          display: 'block',
        }
      );
  }

  if (actual !== null) {
    actual.velocity(
      {
        opacity: 0,
      },
      {
        display: 'none',
        queque: false,
        duration: 0,
      }
    );
  }

  next.velocity(
    {
      opacity: 1,
    },
    {
      display: 'block',
      complete: function () {
        next.removeClass('status--hidden').addClass('status--active');
        if (actual !== null) {
          actual.removeClass('status--active').addClass('status--hidden');
        }
      },
    }
  );
};

const loadSummary = (_caller, _callback) => {
  const queryString = window.location.pathname;
  const paths = queryString.split('/');

  const token = paths[paths.length - 1] !== 'zusammenfassung' ? paths[paths.length - 1] : '';
  console.log(token);

  let params = {
    action: 'summary',
    controller: 'Ajax',
    extension: 'tx_vdsurveys',
    typeNum: 787839,
    pageId: $('html').attr('data-page-id'),
    dataType: 'html',
    token: token,
  };

  T3_Ajax.call(
    params,
    _caller,
    function (params, _caller) {},
    function (params, _caller, data) {
      setTimeout(() => {
        Chart.build();
        if (typeof _callback === 'function') {
          _callback();
        }
      }, 500);
      _caller.html(data);
    }
  );
};

const saveData = (_caller, next, switchPage) => {
  if (typeof switchPage === 'undefined') {
    switchPage = false;
  }

  const form = getForm(_caller);
  const stepActual = form.attr('data-actual-step');
  const stepsOverall = form.attr('data-steps-overall');

  const showLoader =
    form.attr('data-loader') === '1' || form.attr('data-loader') === 'true' ? true : false;

  console.log('--- formData ---');
  console.log(getItemData(_caller));

  let params = {
    action: 'saveData',
    controller: 'Ajax',
    extension: 'tx_vdsurveys',
    typeNum: 787839,
    step: form.attr('data-step-actual'),
    stepId: form.attr('data-step-id'),
    stepsOverall: form.attr('data-steps-overall'),
    formData: getItemData(_caller),
  };

  T3_Ajax.call(
    params,
    _caller,
    function () {
      if (!switchPage) {
        next.find('.rating').removeClass('status--active').addClass('status status--inactive');

        if (showLoader) {
          let loader = Loader.build({
            message: 'Daten werden verarbeitet',
          });
          if (next.find('.vd-loader').length < 1) {
            next.find('.answer__selection').append(loader);
          }
        }
      } else {
        let loader = Loader.build({
          message: 'Daten werden verarbeitet',
        });
        _caller.parents('.vd-form').find('.answers-block').velocity('fadeOut', {
          duration: 350,
          queue: false,
        });

        if (showLoader) {
          _caller.parents('.vd-form').append(loader);
        }
      }
    },
    function () {
      if (!switchPage) {
        if (showLoader) {
          next.find('.vd-loader').velocity('fadeOut', {
            duration: 0,
            queue: false,
            complete: function () {
              next.find('.vd-loader').remove();
            },
          });
        }
        next.find('.rating').removeClass('status--inactive').addClass('status status--active');
        toggleProcessingStatus('stop');
        fadeOverlay('hide');
      } else {
        showSuccessInfo();
      }
    }
  );

  //var target = $(this).parents('.vd-form').attr('data-step-next-target');
  //window.location.href=target;
};

const showSuccessInfo = () => {
  $('.additionalContent, .additionalContent > *').velocity('fadeIn', {
    duration: 0,
    complete: function () {
      toggleProcessingStatus('stop');
      fadeOverlay('hide');
    },
  });
};

const pinFooter = (action) => {
  if (typeof action === 'undefined') {
    action = 'pin';
  }
  if (action === 'pin') {
    $('body').addClass('fixFooter');
  } else {
    $('body').removeClass('fixFooter');
  }
};

const toggleProcessingStatus = (action) => {
  if (typeof action === 'undefined') {
    action = 'start';
  }

  const className = 'processing';

  if (action === 'start') {
    $('body').addClass(className);
  } else {
    $('body').removeClass(className);
  }
};

const isEven = (value) => {
  if (value % 2 == 0) return true;
  else return false;
};

const test = () => {
  alert('Survey module runnin ...');
};

const initSetSessinData = () => {
  let params = {
    action: 'getSessionData',
    controller: 'Ajax',
    extension: 'tx_vdsurveys',
    typeNum: 787839,
  };

  let caller = $('.answer__selection');
  var sessionData = JSON.stringify([]);

  T3_Ajax.call(
      params,
      caller,
      function (params, _caller) {
        // console.log(params);
      },
      function (params, _caller, data) {
        if (typeof data.data === 'undefined') return;
        sessionData = JSON.parse(data.data);
        if(Object.keys(sessionData).length) {
          for(var key in sessionData) {

            let stepContainer = $('[data-step-id="'+key+'"]');
            let selectFields = sessionData[key];
            Object.keys(selectFields).forEach(selectId=>{
              $('#'+selectId).val(selectFields[selectId]);
              $('#'+selectId).parents('.answer__selection').find('[data-id="'+selectFields[selectId]+'"]').addClass('status status--selected');
            });

          }
        }
      }
  );
}
const initAnswers = () => {
  let type = 'circle';

  $('.answer__selection select').each(function () {
    let _select = $(this);
    $(this).hide(0);
    let noi = 0;
    $(this)
      .find('option')
      .each(function () {
        if (parseInt($(this).val()) > noi) {
          noi = parseInt($(this).val());
        }
      });

    let rating = '<div class="rating">';

    rating = rating.concat(
      '<div class="rating__label rating__label--lowest">Trifft nicht zu</div>'
    );

    const value = _select.find('option:selected').val();

    for (let i = 1; i <= noi; i++) {
      const status = i <= value ? ' status status--selected' : '';
      rating = rating.concat(
        '<div class="rating__item rating__item--' +
          type +
          status +
          '" ' +
          'title="Mit ' +
          i +
          ' von 4 abstimmen" ' +
          'data-action="rate-answer" ' +
          'tabindex="' +
          i +
          '" ' +
          'role="link" ' +
          'data-id="' +
          i +
          '">' +
          '<div class="rating__item__wrapper"><span>' +
          i +
          '</span></div></div>'
      );
    }

    rating = rating.concat('<div class="rating__label rating__label--highest">Trifft zu</div>');

    rating = rating.concat('</div>');
    _select.parents('.answer__selection').append(rating);
  });

  if ($('.vd-form[data-show="single-item"]').length > 0) {
    $('.vd-form[data-show="single-item"]').each(function () {
      var i = 0;
      $(this)
        .find('.answer')
        .each(function () {
          var status = i === 0 ? 'active' : 'hidden';
          $(this).addClass('status status--' + status);
          i++;
        });
    });
    $('.vd-form[data-show="single-item"]').each(function () {
      $(this)
        .find('.answers-block')
        .each(function () {
          if ($(this).find('.answer.status.status--active').length > 0) {
            $(this).addClass('status status--active');
          } else {
            $(this).addClass('status status--hidden');
          }
        });
    });

    if (isFirstAnswer()) {
      $('.vd-form')
        .find('.answers-block.status--active .answer.status--active')
        .find('[data-action="previous-answer"]')
        .velocity('fadeOut', { duration: 0 });
    }
  }

  initSetSessinData();
};

const getSessionData = (_caller) => {
  let params = {
    action: 'getSessionData',
    controller: 'Ajax',
    extension: 'tx_vdsurveys',
    typeNum: 787839,
  };

  T3_Ajax.call(
    params,
    _caller,
    function (params, _caller) {},
    function (params, _caller, data) {
      console.log(data);
      if ('token' in data) {
        _caller.attr('href', _caller.attr('href') + '/' + data.token);
      }
    }
  );
};

/**
 * export methods
 */

export {
  actions,
  fetchFormData,
  getSessionData,
  initAnswers,
  initProgressGraphic,
  isFirstAnswer,
  loadSummary,
  nextStep,
  prevStep,
  saveData,
  test,
};
